// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3GA7u","resendInfoText":"OnGoingPaymentBox_resendInfoText__1nHKq"};